import gsap from 'gsap';
// import { ScrollSmoother } from 'gsap/ScrollSmoother';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Lenis from 'lenis';

gsap.registerPlugin(ScrollTrigger);
// gsap.registerPlugin(ScrollSmoother);

// ScrollSmoother.create({
//     smooth: 0.6, // how long (in seconds) it takes to "catch up" to the native scroll position
//     effects: true, // looks for data-speed and data-lag attributes on elements
//     smoothTouch: 0.1, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
// });

const lenis = new Lenis({
    autoRaf: true,
    duration: 0.6,
});

lenis.on('scroll', ScrollTrigger.update);
